<template>
  <div class="pagoda-layout-v2__header">
    <div class="pagoda-layout-v2__header-title">
      <slot name="header-left"></slot>
    </div>
    <div
      class="pagoda-layout-v2__header-menu"
      v-if="menu.length"
    >
      <slot name="before-menu"></slot>
      <ul>
        <li
          v-for="menuItem in menu"
          :class="{active: activeMenu === menuItem}"
          @click="$emit('select-header-menu', menuItem)"
        >{{menuItem.label}}</li>
      </ul>
      <slot name="after-menu"></slot>
    </div>
    <div class="pagoda-layout-v2__header-right">
      <slot name="header-right"></slot>
    </div>
  </div>
</template>

<script>
import { getEmptyArray } from '../../../utils'

import { getMathUrlCollection } from '../../../utils/url'

export default {
  name: 'LayoutV2Header',
  props: {
    menu: {
      type: Array,
      default: getEmptyArray
    }
  },
  inject: ['layoutInstance'],
  data() {
    return {
      activeMenu: ''
    }
  },
  mounted() {
    if (this.layoutInstance) {
      this.layoutInstance.hasHeader = true
    }
  },
  activated() {
    if (this.layoutInstance) {
      this.layoutInstance.hasHeader = true
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.setDefaultActive()
      }
    },
    menu() {
      this.setDefaultActive()
    }
  },
  methods: {
    setDefaultActive() {
      const fullPath = this.$route.fullPath.split('?')[0]
      const mathUrlCollection = getMathUrlCollection(fullPath)
      this.activeMenu = null

      for (const menuItem of this.menu) {
        const _mathUrlCollection = menuItem.pathMatchFull ? [fullPath] : mathUrlCollection

        if (_mathUrlCollection.includes(menuItem.url)) {
          this.activeMenu = menuItem
        }
      }
    }
  },
  deactivated() {
    if (this.layoutInstance) {
      this.layoutInstance.hasHeader = false
    }
  },
  beforeDestroy() {
    if (this.layoutInstance) {
      this.layoutInstance.hasHeader = false
    }
  }
}
</script>
